import {Box, Color, Spacing, Typography} from "kvweb-ui";
import imageMigrating from "../../../assets/images/onboarding-retail/migrating.gif";
import LinearProgressEx from "../../Static/Progress/LinearProgressEx";
import React from "react";

const ImageMigrating: React.FC<{
  processPercent: number
}> = ({processPercent}) => {
  return <>
    <Box display={"flex"} justifyContent={"center"}>
      <img alt={"Đang đồng bộ"} width={"300px"} src={imageMigrating} />
      {/*<ImageGif/>*/}
    </Box>
    <Box sx={{ marginTop: Spacing["space-xxl"], marginLeft: "30px" }}>
      <LinearProgressEx progress={processPercent} />
    </Box>
    <Box display={"flex"} justifyContent={"center"} mt={Spacing["space-m"]}>
      <Typography textType={"text18S"} color={Color["black-850"]}>
        {/*Đang đồng bộ sản phẩm <Typography display={'inline'} textType={'text18S'} color={Color["primary-500"]}>{productSynceInfo.synced}/{productSynceInfo.total}</Typography>*/}
        Đang đồng bộ sản phẩm &nbsp;
        <Typography
          display={"inline"}
          textType={"text18S"}
          color={Color["primary-500"]}
        >
          {processPercent}%
        </Typography>
      </Typography>
    </Box>
    <Box display={"flex"} justifyContent={"center"} mt={Spacing["space-m"]}>
      <Typography
        textType={"text14R"}
        color={Color["black-850"]}
        textAlign={"center"}
      >
        Trong quá trình đồng bộ sản phẩm, bạn cũng có thể thao tác khác như
        thiết lập banner, logo và thông tin cửa hàng
      </Typography>
    </Box>
  </>
}

export default ImageMigrating
